import {getRequest} from './apiRequests';
import {Project} from '@/domain/entities/Project';
import localStorageRepository from '@/domain/repository/LocalStorageRepository';
import {FeatureCollection, MultiPolygon} from 'geojson';
import {Dispute} from '@/domain/entities/Dispute';

const PROJECTS_URL = 'projects/';

const projectsRepository = {
  getProjects: (): Promise<Array<Project>> => {
    const {access} = localStorageRepository.getCredentials();
    return getRequest<Array<Project>>({
      path: PROJECTS_URL,
      headers: {
        'Authorization': `Bearer ${access}`
      }
    });
  },
  getDisputesOverlayByProject: (projectUuid: string): Promise<FeatureCollection<MultiPolygon, Omit<Dispute, 'geom'>>> => {
    const {access} = localStorageRepository.getCredentials();
    return getRequest<FeatureCollection<MultiPolygon, Omit<Dispute, 'geom'>>>({
      path: `projects/${projectUuid}/disputes`,
      headers: {
        'Authorization': `Bearer ${access}`
      }
    });
  }
};

export default projectsRepository;